import { useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import PortalLayout from '../../layouts/PortalLayout';
import { SidebarUser, SidebarLabel, SidebarNavItem } from '../../layouts/SidebarNav';
import { PortalCard, StatsRow, DataTable } from './_portal.css';

const MENU = [
  { id: 'overview', icon: '📊', label: 'Overview' },
  { id: 'bookings', icon: '📅', label: 'Bookings', badge: 412 },
  { id: 'trustians', icon: '🏍️', label: 'Trustians', badge: 87 },
  { id: 'tests', icon: '🔬', label: 'Tests Catalog' },
  { id: 'packages', icon: '📦', label: 'Packages' },
  { id: 'centres', icon: '🏢', label: 'Centres' },
  { id: 'users', icon: '👥', label: 'Users' },
  { id: 'revenue', icon: '💰', label: 'Revenue' },
  { id: 'settings', icon: '⚙️', label: 'Settings' },
];

const AdminPortal = () => {
  const [active, setActive] = useState('overview');

  return (
    <PortalLayout
      brand="TrustLab"
      brandSub="Admin"
      accent="#00B49A"
      sidebarWidth={250}
      topbarTitle="OPERATIONS CONTROL"
      topbarRight={
        <Stack direction="row" spacing={1}>
          <Button variant="outlined" size="small" sx={{ display: { xs: 'none', sm: 'inline-flex' } }}>
            Audit Log
          </Button>
          <Button variant="contained" color="primary" size="small">
            + Centre
          </Button>
        </Stack>
      }
      sidebar={
        <>
          <SidebarUser initials="OA" name="Ops Admin" role="Operations Team" />
          <SidebarLabel>Operations</SidebarLabel>
          {MENU.map((m) => (
            <SidebarNavItem key={m.id} {...m} active={active === m.id} onClick={() => setActive(m.id)} />
          ))}
        </>
      }
    >
      <StatsRow
        items={[
          { label: 'Bookings Today', value: 412, sub: '+18% vs last week' },
          { label: 'Revenue (MTD)', value: '₹28.7L', sub: '+22% MoM', accent: '#F0B429' },
          { label: 'Active Trustians', value: 87, sub: 'Across 13 cities', accent: '#6366F1' },
          { label: 'Avg TAT', value: '8.2h', sub: 'Target: 12h', accent: '#00B49A' },
        ]}
      />

      <Grid container spacing={2.5}>
        <Grid item xs={12} md={8}>
          <PortalCard title="Today's Bookings — All Cities">
            <DataTable
              columns={['Booking', 'Patient', 'City', 'Test', 'Slot', 'Status']}
              rows={[
                ['TL-A7X3K2', 'Priya Kaur', 'Hyderabad', 'Full Body Adv', '07:00 AM', '🏍️ En route'],
                ['TL-A7X3K3', 'Rohit S.', 'Bangalore', 'HbA1c', '07:30 AM', '✓ Collected'],
                ['TL-A7X3K4', 'Ananya M.', 'Gurugram', 'Thyroid', '08:00 AM', '⏳ Assigned'],
                ['TL-A7X3K5', 'Suresh V.', 'Hyderabad', 'Diabetes Care', '08:30 AM', '✓ Collected'],
                ['TL-A7X3K6', 'Neha P.', 'Mumbai', "Women's Wellness", '09:00 AM', '📅 Scheduled'],
              ]}
            />
          </PortalCard>
        </Grid>
        <Grid item xs={12} md={4}>
          <PortalCard title="City Performance">
            <Stack spacing={1.5}>
              {[
                ['Hyderabad', 128, '₹8.2L', 34],
                ['Bangalore', 94, '₹6.4L', 22],
                ['Gurugram', 76, '₹5.1L', 15],
                ['Mumbai', 62, '₹4.8L', 12],
                ['Delhi', 52, '₹4.2L', 8],
              ].map(([c, b, r, t]) => (
                <Box key={c} sx={{ p: 1.5, bgcolor: '#F4F6F8', borderRadius: '6px' }}>
                  <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.5 }}>
                    <Typography sx={{ fontSize: 13, fontWeight: 700, color: '#10151C' }}>{c}</Typography>
                    <Typography sx={{ fontSize: 13, fontWeight: 700, color: '#F0B429' }}>{r}</Typography>
                  </Stack>
                  <Typography sx={{ fontSize: 11, color: '#6B8079' }}>
                    {b} bookings · {t} Trustians
                  </Typography>
                </Box>
              ))}
            </Stack>
          </PortalCard>
        </Grid>
        <Grid item xs={12}>
          <PortalCard title="Trustian Fleet — Live Status">
            <Grid container spacing={1.5}>
              {[
                ['Available', 23, '#00B49A'],
                ['En route', 34, '#F0B429'],
                ['At customer', 18, '#6366F1'],
                ['Break', 8, '#94A3B8'],
                ['Offline', 4, '#EF4444'],
              ].map(([l, v, clr]) => (
                <Grid key={l} item xs={6} md>
                  <Box sx={{ p: 2, border: `2px solid ${clr}`, borderRadius: '6px', textAlign: 'center' }}>
                    <Typography className="serif" sx={{ fontSize: 28, fontWeight: 700, color: clr, lineHeight: 1 }}>
                      {v}
                    </Typography>
                    <Typography sx={{ fontSize: 11, color: '#6B8079', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', mt: 0.5 }}>
                      {l}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </PortalCard>
        </Grid>
      </Grid>
    </PortalLayout>
  );
};

export default AdminPortal;
